import { httpClient } from 'providers/clients/httpClient';
import {
  GetBatchEditPreflightParams,
  GetBatchEditPreflightResult,
  PostBatchEditParams,
  PostBatchEditResult,
} from 'utility/types/dataProvider';

// -----------------------------------------------
// ------------ BATCH EDIT PROVIDER --------------
// -----------------------------------------------
export const batchEditProvider = {
  getBatchEditPreflight: async (
    param: GetBatchEditPreflightParams,
  ): Promise<GetBatchEditPreflightResult> => {
    try {
      const url = `/core/batch/task/preflight/`;

      const { data } = await httpClient({
        url: url,
        method: 'POST',
        data: JSON.stringify(param),
      });

      return data;
    } catch (error) {
      console.error('[getBatchEditPreflight] Error:', error);
      throw error;
    }
  },
  createBatchEditTask: async (
    param: PostBatchEditParams,
  ): Promise<PostBatchEditResult> => {
    try {
      const url = `/core/batch/task/`;

      const { data } = await httpClient({
        url: url,
        method: 'POST',
        data: JSON.stringify(param),
      });

      return data;
    } catch (error) {
      console.error('[createBatchEditTask] Error:', error);
      throw error;
    }
  },
};
